/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Pack_LeadInputs */

const en_price_page_pack_lead = /** @type {(inputs: Price_Page_Pack_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Packs that count themselves.`)
};

const pl_price_page_pack_lead = /** @type {(inputs: Price_Page_Pack_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakiety, które liczą się same.`)
};

/**
* | output |
* | --- |
* | "Packs that count themselves." |
*
* @param {Price_Page_Pack_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_pack_lead = /** @type {((inputs?: Price_Page_Pack_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Pack_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_pack_lead(inputs)
	return en_price_page_pack_lead(inputs)
});